export const SET_NAME = 'PA/SET_NAME'
export const SET_PHONE_NUMBER = 'PA/SET_PHONE_NUMBER'
export const SET_PROFESSION = 'PA/SET_PROFESSION'
export const SET_AVATAR = 'PA/SET_AVATAR'
export const SET_DNI = 'PA/SET_DNI'
export const SET_CENSO = 'PA/SET_CENSO'
export const SET_IDENTITY_CARD = 'PA/SET_IDENTITY_CARD'
